import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles } from 'tss-react/mui';
import Grid from '../Grid';
import { Typography } from '../Typography';
const useStyles = makeStyles()({
    formSectionWithTitle: {
        margin: '30px auto',
        maxWidth: '100%',
    },
    formSectionWithoutTitle: {
        margin: 'auto',
        maxWidth: '100%',
    },
});
export const FormSection = ({ title, children, subTitle, direction, className, }) => {
    const { classes, cx } = useStyles();
    return (_jsxs(Grid, { container: true, spacing: 4, direction: direction || 'column', className: cx(title ? classes.formSectionWithTitle : classes.formSectionWithoutTitle, className), children: [title || subTitle ? (title && typeof title !== 'string' ? (title) : (_jsxs(Grid, { item: true, children: [title && _jsx(Typography.H2, { children: title }), subTitle && (_jsx(Typography.Caption, { color: "muted", children: subTitle }))] }))) : null, children] }));
};
